import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiFetch } from "./client";
import type { LoginRequest, WhoamiResponse } from "./types";

export function useWhoami() {
  return useQuery({
    queryKey: ["whoami"],
    queryFn: () => apiFetch<WhoamiResponse>("/api/v1/whoami"),
    staleTime: 5 * 60_000,
  });
}

export function useLogin() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: LoginRequest) =>
      apiFetch<{ ok: boolean }>("/api/v1/login", { method: "POST", body }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["whoami"] }),
  });
}

export function useLogout() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => apiFetch<{ ok: boolean }>("/api/v1/logout", { method: "POST" }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["whoami"] }),
  });
}
